module.exports = __webpack_public_path__ + "img/react-logo.9623806f.svg";